<script setup lang="ts">
import { computed } from 'vue';

import { Label } from '@/components/ui/label';
import { useTenantStore } from '@/stores/tenant';
import { useUserStore } from '@/stores/user';

const user = useUserStore();

const tenantStore = useTenantStore();
const tenantName = computed(() => {
    return tenantStore.tenantName;
});
const tenantRole = computed(() => {
    return tenantStore.tenantRoles?.includes('Tenant Admin')
        ? 'Admin'
        : 'Member';
});
</script>

<template>
    <div class="title flex flex-col gap-6">
        <div class="flex flex-col gap-2">
            <h2 class="text-xl font-semibold">User profile</h2>
            <p class="text-sm text-muted-foreground">
                Profile details and personal information.
            </p>
        </div>
        <!-- General information -->
        <div class="general-information grid grid-cols-1 gap-4 lg:grid-cols-2">
            <div class="space-y-2">
                <Label>First name</Label>
                <div
                    class="min-h-10 rounded-md border bg-muted/40 px-3 py-2 text-sm flex items-center"
                >
                    {{ user.firstName || '-' }}
                </div>
            </div>

            <div class="space-y-2">
                <Label>Last name</Label>
                <div
                    class="min-h-10 rounded-md border bg-muted/40 px-3 py-2 text-sm flex items-center"
                >
                    {{ user.lastName || '-' }}
                </div>
            </div>

            <div class="space-y-2">
                <Label>Email</Label>
                <div
                    class="min-h-10 rounded-md border bg-muted/40 px-3 py-2 text-sm flex items-center break-all"
                >
                    {{ user.email || '-' }}
                </div>
            </div>

            <div class="space-y-2">
                <Label>Phone number</Label>
                <div
                    class="min-h-10 rounded-md border bg-muted/40 px-3 py-2 text-sm flex items-center"
                >
                    {{ user.phoneNumber || '-' }}
                </div>
            </div>

            <div class="space-y-2">
                <Label>Workspace name</Label>
                <div
                    class="min-h-10 rounded-md border bg-muted/40 px-3 py-2 text-sm flex items-center"
                >
                    {{ tenantName || '-' }}
                </div>
            </div>

            <div class="space-y-2">
                <Label>Role</Label>
                <div
                    class="min-h-10 rounded-md border bg-muted/40 px-3 py-2 text-sm flex items-center"
                >
                    {{ tenantRole || '-' }}
                </div>
            </div>
        </div>
    </div>
</template>
